import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { MobileActionBar } from "@/components/MobileActionBar";
import { PublicationCard } from "@/components/Publications";
import { SectionHeading, Reveal } from "@/components/motion";
import { publications } from "@/data/publications";
import { DOCTOR } from "@/config/doctorConfig";

export default function PublicationsPage() {
  return (
    <>
      <Helmet>
        <title>{`Research & Publications | ${DOCTOR.name}, Bhopal`}</title>
        <meta
          name="description"
          content="Peer-reviewed publications by Dr. Suyash Bhadoriya, MD (Internal Medicine), Bhopal — research in cardiology outcomes, pulmonary rehabilitation and hepatorenal manifestations."
        />
        <link rel="canonical" href="https://drsuyashbhadoriya.com/publications" />
        <meta property="og:url" content="https://drsuyashbhadoriya.com/publications" />
      </Helmet>
      <Header />
      <main className="pt-28 lg:pt-36 pb-20 bg-background min-h-screen" data-testid="publications-page">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-xs font-mono tracking-wide text-slate-500 uppercase mb-8">
              <Link to="/" className="hover:text-teal-700 transition-colors">Home</Link>
              <span aria-hidden="true">/</span>
              <span className="text-teal-700">Publications</span>
            </nav>
          </Reveal>
          <SectionHeading
            number="Research"
            eyebrow="Research & Publications"
            title="Academic Research & Publications"
            sub={`Peer-reviewed research by ${DOCTOR.name}, ${DOCTOR.qualifications}. Each entry links to the publisher's record via its DOI.`}
          />
          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="publications-page-grid">
            {publications.map((pub, i) => (
              <PublicationCard key={pub.id} pub={pub} index={i} />
            ))}
          </div>
        </div>
      </main>
      <Footer />
      <MobileActionBar />
    </>
  );
}
